export const HSL_GRADIENT_WIDTH = 150;
export const HSL_GRADIENT_HEIGHT = 150;
export const OPACITY_HEIGHT = 20;
export const HUE_WIDTH = 20;
export const COLOR_SQUARE_WIDTH = 30;
export const COLOR_SQUARE_HEIGHT = 30;
export const COLOR_SQUARE_STROKE_WIDTH = 3;
